import { ApproveVocabulary } from 'common/ui/shared/approve-modal';

export const approveDeleteVocabulary: ApproveVocabulary = {
  yesBtn: 'Delete',
  noBtn: 'Cancel',
  description: 'Are you sure you want to delete this entry?',
};
